import { Outlet } from "react-router-dom";
import NavBar from "../components/NavBar";

export default function Logopedia() {
  return (
    <div>
      <NavBar user={{ role: "logopeda" }} />
      <main style={{ padding: "1rem" }}>
        <Outlet /> {/* 👈 Aquí se cargará PsicologiaHome, Pacientes, Calendario, etc */}
      </main>
    </div>
  );
}
